import { useEffect, useState } from 'react';

import type { PageSummary } from '../api';
import { fetchBacklinks } from '../api';
import { t } from '../i18n';

/**
 * The pages that point at this page. Only the ones the reader may see are
 * shown; the server decides that, not this component.
 */
export function Backlinks({ pageId }: { pageId: string }): React.ReactElement | null {
  const [items, setItems] = useState<PageSummary[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    void fetchBacklinks(pageId)
      .then((found) => {
        if (!cancelled) setItems(found);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, [pageId]);

  if (!items || items.length === 0) return null;

  return (
    <section className="backlinks">
      <h2 className="backlinks__title">{t('backlinks.title')}</h2>
      <ul className="backlinks__list">
        {items.map((item) => (
          <li key={item.id}>
            <a className="backlinks__link" href={`#/p/${item.id}`}>
              <span className="backlinks__icon" aria-hidden="true">
                {item.icon || '📄'}
              </span>
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
